import React, { Component, Dispatch } from 'react';
import { connect } from 'react-redux';
import { SofaPanel } from '@sofology/sofologycomponents';
import { RouteComponentProps } from 'react-router';

import './OrderPage.scss';

import { AppState } from 'store';
import { generateDispatchToPropsMap } from 'helpers';
import { processOrder, ProcessOrderFunc } from 'store/checkout/actions';
import { Loader } from 'components';
import { BasketErrorModel } from 'models/Errors';
import { routes } from 'routes';

interface OwnProps {
}

interface StateProps {
    isOrderProcessing: boolean;
    isLookingForLastOrder: boolean;
    isOrderPlacing: boolean;
    processOrderError: BasketErrorModel | null;
}

interface DispatchProps {
    processOrder: ProcessOrderFunc;
}

class OrderPage extends Component<OwnProps & StateProps & DispatchProps & RouteComponentProps> {
    componentDidMount() {
        this.props.processOrder();
    }

    componentDidUpdate(prevProps: OwnProps & StateProps & DispatchProps & RouteComponentProps): void {
        if (prevProps.isOrderProcessing && !this.props.isOrderProcessing && !this.props.processOrderError) {
            this.props.history.push(routes.orderSummaryPage.path);
        }
    }

    render(): JSX.Element {
        const { isOrderProcessing, processOrderError } = this.props;

        return (
            <div className='order-page'>
                <SofaPanel>
                    {isOrderProcessing && this.renderOrderProcessing()}
                    {processOrderError && this.renderOrderError()}
                </SofaPanel>
            </div>
        );
    }

    renderOrderProcessing(): JSX.Element {
        const { isOrderProcessing, isOrderPlacing, isLookingForLastOrder } = this.props;

        let statusMessage = 'Loading';

        if (isOrderProcessing && (isOrderPlacing || isLookingForLastOrder)) {
            statusMessage = isLookingForLastOrder
                ? 'Looking for your order'
                : 'Processing your order';
        }

        return (
            <div className='order-page__processing'>
                <div className='order-page__processing-message'>{statusMessage}</div>
                <div className='order-page__processing-loader'><Loader show={true} overlay={true} /></div>
            </div>
        );
    }

    renderOrderError(): JSX.Element {
        return (
            <div className='order-page__error'>Sorry, there has been an error when trying to place your order, please contact 0800&#160;140&#160;40&#160;40.</div>
        );
    }
}

function mapStateToProps(state: AppState): StateProps {
    return {
        isOrderProcessing: state.checkoutState.isOrderProcessing,
        isLookingForLastOrder: state.checkoutState.isLookingForLastOrder,
        isOrderPlacing: state.checkoutState.isOrderPlacing,
        processOrderError: state.checkoutState.processOrderError
    };
}

function mapDispatchToProps(dispatch: Dispatch<any>): DispatchProps {
    return generateDispatchToPropsMap(dispatch, [processOrder]);
}

export default connect(mapStateToProps, mapDispatchToProps)(OrderPage);